import { NgModule } from '@angular/core';
import { LeafletMarkerClusterDirective } from './leaflet-markercluster.directive';
import * as ɵngcc0 from '@angular/core';
var LeafletMarkerClusterModule = /** @class */ (function () {
    function LeafletMarkerClusterModule() {
    }
LeafletMarkerClusterModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LeafletMarkerClusterModule });
LeafletMarkerClusterModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function LeafletMarkerClusterModule_Factory(t) { return new (t || LeafletMarkerClusterModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LeafletMarkerClusterModule, { declarations: function () { return [LeafletMarkerClusterDirective]; }, exports: function () { return [LeafletMarkerClusterDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LeafletMarkerClusterModule, [{
        type: NgModule,
        args: [{
                exports: [LeafletMarkerClusterDirective],
                declarations: [LeafletMarkerClusterDirective]
            }]
    }], function () { return []; }, null); })();
    return LeafletMarkerClusterModule;
}());
export { LeafletMarkerClusterModule };

//# sourceMappingURL=leaflet-markercluster.module.js.map